export default __webpack_public_path__ + "static/icon_goldin_dark-75af0baa56f419a7faa27e3ef947fd02.svg";